module.exports = __webpack_public_path__ + "static/media/skiing.6c8e0ba1.svg";